import { ClientTopServices } from './../../../../services/ClientTop.services'
// <reference path="../../../../../../node_modules/@angular/core/src/metadata/directives.d.ts"/>
import { Component, HostListener, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { FormBuilder } from '@angular/forms'
import { SharedServices } from '../../../../services/shared.services'
import { ModalService } from '../../../../services/modal.service'

@Component({
    selector: 'app-modal-new-client-doctor',
    templateUrl: './modal-new-client.component.html',
    styleUrls: [
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/main-view.component.css',
        '../../../../stagingcss/lui-select.component.css',
    ],
})

export class ModalNewClientDoctorComponent implements OnInit {

    ModalNewClientDoctor = 'hidden'
    listStaff
    selectedDoctor
    selectedCordinator
    modalSelected
    arraySelected = [{ role: '', id: '' }, { role: '', id: '' }]
    alertMail = true
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    routerLink
    filterCordinator
    filterDoctor
    listDoctor
    listCodinator
    statusEsc

    constructor(private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private _sharedService: SharedServices,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices) {
        this.modalService.changeEmitted$.subscribe(
            success => {
                if (success[0] === 'activeModalDoctor') {
                    this.ModalNewClientDoctor = 'active'
                    this.statusEsc = true
                }
                if (success[1] === 'cordinator') {
                    this.listStaff = success[3]
                    this.listCodinator = this.listStaff
                    this.modalSelected = 'cordinator'
                    if (this.listCodinator) {
                        this.listCodinator.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                    }
                } else if (success[1] === 'doctor') {
                    this.listStaff = success[2]
                    this.listDoctor = this.listStaff
                    this.modalSelected = 'doctor'
                    if (this.listDoctor) {
                        this.listDoctor.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                    }
                }
                if (success === 'activeAlertNewClientPage') {
                    this.alertMail = false
                    this.alertLanguage()
                }
                if (success && success[0] === 'checkRotesLink') {
                    this.routerLink = success[1]
                }
                //
            })
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        if (this.statusEsc) {
            if (keyPressed === 27) {
                this.hidenModalNewClientListDoctor()
            }
        }
    }

    // hiden modal
    hidenModalNewClientListDoctor() {
        this.ModalNewClientDoctor = 'hidden'
        this.statusEsc = false
    }

    // search
    search(option) {
        if (option === 'doctor') {
            if (this.filterDoctor !== '') {
                const searchResult = this.listStaff.filter(staff => ((staff.firstName ? staff.firstName.indexOf(this.filterDoctor) !== -1 : false) || (staff.familyName ? staff.familyName.indexOf(this.filterDoctor) !== -1 : false)))
                //
                if (searchResult) {
                    this.listDoctor = searchResult
                    // this.listDoctor.push(searchResult);
                } else {
                    this.listDoctor = []
                }
            } else {
                this.listDoctor = this.listStaff
            }
            if (this.listDoctor) {
                this.listDoctor.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
            }
        }
        if (option === 'cordinator') {
            if (this.filterCordinator !== '') {
                const searchResult = this.listStaff.filter(staff => ((staff.firstName ? staff.firstName.indexOf(this.filterCordinator) !== -1 : false) || (staff.familyName ? staff.familyName.indexOf(this.filterCordinator) !== -1 : false)))
                if (searchResult) {
                    //
                    this.listCodinator = searchResult
                    // this.listCodinator.push(searchResult);
                    //
                } else {
                    this.listCodinator = []
                }
            } else {
                this.listCodinator = this.listStaff
            }
            if (this.listCodinator) {
                this.listCodinator.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
            }
        }
    }

    ngOnInit() {
    }

    selectDoctor(index) {
        if (this.modalSelected === 'cordinator') {
            this.selectedCordinator = this.listStaff[index]._id
            this.ModalNewClientDoctor = 'hidden'
            this.arraySelected[1] = { role: 'cordinator', id: this.selectedCordinator }
        } else if (this.modalSelected === 'doctor') {
            this.selectedDoctor = this.listStaff[index]._id
            this.ModalNewClientDoctor = 'hidden'
            this.arraySelected[0] = { role: 'doctor', id: this.selectedDoctor }
        }
        //
        this._sharedService.emitChangeParent(this.arraySelected)
    }

    // alert
    cancelAlert() {
        this.alertMail = true
    }

    alertDiscard() {
        this._sharedService.emitChange('statusDiscard')
        this._sharedService.emitChange('activeAlertSaveMail')
        this.alertMail = true
        this.selectedDoctor = ''
        this.selectedCordinator = ''
        this.modalSelected = ''
        this.arraySelected = [{ role: '', id: '' }, { role: '', id: '' }]
        const emit: any = {}
        emit['active'] = true
        this.clientTopServices.emitChangeActiveIndex(emit)
        // this.router.navigateByUrl('/app/top');
    }

    saveMail() {
        this._sharedService.emitChange('saveNewClient')
        this.alertMail = true
    }

    alertLanguage() {
        this.langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client/new-client/modal-new-client.component.ts